
<div *ngIf="showLocationlist(data | async) | async">
  <button
    mat-button
    [matMenuTriggerFor]="menuLocations"
  >
    <div style="font-size: 12px; display: flex; gap: 8px;" class="text-white">
      <!-- <mat-icon style="padding-top: 8px; padding-right: 4px;">pin_drop</mat-icon> -->
      <span *ngIf="selectedLocation.id > 0" style="font-size:1.2rem;">
        {{ selectedLocation.name }} Location
      </span>
      <span *ngIf="selectedLocation.id === 0" style="font-size:1.2rem;">
        Location not selected
      </span>
      <mat-icon style="margin-top: 4px;">arrow_drop_down</mat-icon>
    </div>
  </button>
  
  <mat-menu #menuLocations="matMenu">
  <div>
    <div>
      <button mat-menu-item (click)="setLocation(noLocation)">
        <div>
          <mat-icon *ngIf="selectedLocation.id !==noLocation.id">radio_button_unchecked</mat-icon>
          <mat-icon *ngIf="selectedLocation.id ===noLocation.id" color="primary">radio_button_checked</mat-icon>
          <span>Location not selected</span>
        </div>
      </button>
    </div>
  
    <div *ngFor="let location of (data | async)" style="width: 206px;">
      <button mat-menu-item (click)="setLocation(location)" *ngIf="location.active && checkRole(location)">
       <div>
        <mat-icon *ngIf="selectedLocation.id !==location.id">radio_button_unchecked</mat-icon>
        <mat-icon *ngIf="selectedLocation.id ===location.id" color="primary">radio_button_checked</mat-icon>
        <span>{{ location.name }}</span>
       </div>
      </button>
    </div>
  
    <div *ngIf="(data | async).length === 0" style="width: 206px;">
      <button mat-menu-item (click)="createLocation(location)">
        <div>
         <span>Create a Location</span>
        </div>
       </button>
    </div>
  </div>
   
  </mat-menu>
</div>

<ng-template #ONE_LOCATION>
  <div *ngIf="(data$ | async) as data">
    <div style="font-size: 12px; display: flex; gap: 8px; font-size:1.2rem;">
      <mat-icon style="font-size: 16pt; padding-top: 5px;">place</mat-icon>
      <div *ngIf="selectedLocation.id > 0">
        {{ selectedLocation.name }} Location
      </div>
      <div *ngIf="selectedLocation.id === 0">
        Location not selected
      </div>
    </div>
  </div>
</ng-template>



